import React from "react";
import {Route, IndexRoute} from "react-router";
import Account from "./components/screens/account";
import IntegrationGuideOverview from "./components/screens/integration-guide-overview";
import App from "./components/screens/app";
import Applications from "./components/screens/applications";
import Docs from "./components/screens/docs";
import Terms from "./components/screens/terms";
import Glossary from "./components/screens/glossary"
import Downloads from "./components/screens/downloads"
import Plugins from "./components/screens/plugins"
import Enroll from "./components/screens/enroll";
import Faq from "./components/screens/faq";
import Troubleshooting from "./components/screens/troubleshooting";
import ImageGuidelines from "./components/screens/image-guidelines";
import Search from "./components/screens/search";
import WebserviceGuideV2 from "./components/screens/webservice-guide";
import NotFound from "./components/screens/notfound";
import RecoverPassword from "./components/screens/recover-password";
import ReleaseNotes from "./components/screens/release-notes";
import ResetPassword from "./components/screens/reset-password";
import FirstApplication from "./components/screens/first-application";
import SignIn from "./components/screens/signin";
import CompleteSignup from "./components/screens/complete-signup";
import SignInEmailSent from "./components/screens/signin-email-sent";
import Stats from "./components/screens/stats";
import SubmittingAGoodBug from "./components/screens/submitting-a-good-bug";
import GeneralQuestions from "./components/screens/general-questions";
import UsageConsole from "./components/screens/usage-console";
import SpoofBountyProgram from "./components/screens/spoof-bounty-program";
import Quote from "./components/screens/quote";
import UserHandler from "js/utilities/user-handler";
import RetrievingImagesGuide from "./components/screens/zoom-audit-trail";
import StringCustomizationGuide from "./components/screens/string-customization-guide";
import MatchingGuide from "./components/screens/matching-guide";
import ZoomUserExperienceDetails from "./components/screens/zoom-user-experience-details";
import AgeCheckGuide from "./components/screens/age-check-guide";
import PhotoIDMatchGuide from "./components/screens/photo-id-match-guide";
import UserExperienceBestPractices from "./components/screens/user-experience-best-practices";
import ZoomShortExpirationWildcardLicenses from "./components/screens/zoom-short-expiration-wildcard-licenses";
import ZoomConfigurationOptions from "./components/screens/zoom-configuration-options";
import ZoomSdkSizeAndAppThinning from "./components/screens/zoom-sdk-size-and-app-thinning";
import ZoomClientSideSecurityMethodologies from "./components/screens/zoom-client-side-security-methodologies";
import ZoomDockerHelp from "./components/screens/zoom-docker-help";
import ZoomIosIntegration from "./components/screens/zoom-ios";
import ZoomAndroidIntegration from "./components/screens/zoom-android";
import ZoomBrowserDockerHelp from "./components/screens/zoom-browser-docker-help";
import ZoomServerRESTAPI from "./components/screens/zoom-server-rest-api";
import StandardServerRESTAPI from "./components/screens/standard-server-rest-api";
import UICustomization from "./components/screens/ui-customization";
import TechnicalSupport from "./components/screens/technical-support";
import GettingStarted from "./components/screens/getting-started";
import SecurityBestPractices from "./components/screens/security-best-practices";
import Compatibility from "./components/screens/compatibility";
import ServerIntegration from "./components/screens/server-integration";
import Updating from "./components/screens/updating";
import ReleasePractices from "./components/screens/release-practices";
import TroubleshootingServer from "./components/screens/troubleshooting-server";
import Keys from "./components/screens/keys";
import UsageLogs from "./components/screens/usage-logs";
import FaceMapEncryptionKeys from "./components/screens/facemap-encryption-keys";
import TechnicalSpecs from "./components/screens/technical-specs";
import SessionTokens from "./components/screens/session-tokens";
import GoingProductionOverview from "./components/screens/going-production-overview";
import NewReleaseInfo from "./components/screens/new-release-info";
import ZoomServerConsole from "./components/screens/zoom-server-console";
import StandardServerAndDashboard from "./components/screens/standard-server-and-dashboard";
import PhotoIdAntiSpoofingAndAntiTampering from "./components/screens/photo-id-anti-spoofing-and-anti-tampering";
import ServerSDKOverview from "./components/screens/server-sdk-overview";
import VideoTutorials from "./components/screens/video-tutorials";
import RemoveDevMode from "./components/screens/removing-development-mode-watermark";
import Search1N from "./components/screens/1-to-n-search";
import SpoofCheck2D from "./components/screens/2d-spoof-check";

var redirectToDocsIfLoggedIn = (nextState, replace) => {
  if (UserHandler.loggedIn()) {
    replace({pathname: "/docs"})
  }
};

export default(
  <Route>
    <Route path="/" component={App}>
      <IndexRoute component={Docs}/>
      <Route path="account" component={Account}/>
      <Route path="integration-guide-overview" component={IntegrationGuideOverview}/>
      <Route path="applications" component={Applications}/>
      <Route path="docs" component={Docs}/>
      <Route path="terms" component={Terms}/>
      <Route path="glossary" component={Glossary}/>
      <Route path="downloads" component={Downloads}/>
      <Route path="plugins" component={Plugins}/>
      <Route path="enroll" component={Enroll}/>
      <Route path="faq" component={Faq}/>
      <Route path="troubleshooting" component={Troubleshooting}/>
      <Route path="first-application" component={FirstApplication}/>
      <Route path="image-guidelines" component={ImageGuidelines}/>
      <Route path="webservice-guide" component={WebserviceGuideV2}/>
      <Route path="search" component={Search}/>
      <Route path="recover-password" component={RecoverPassword}/>
      <Route path="release-notes" component={ReleaseNotes}/>
      <Route path="reset-password" component={ResetPassword}/>
      <Route path="signin" component={SignIn}/>
      <Route path="complete-signup" component={CompleteSignup}/>
      <Route path="signin-email-sent" component={SignInEmailSent}/>
      <Route path="stats" component={Stats}/>


      <Route path="support" component={SubmittingAGoodBug}/>
      <Route path="submitting-a-good-bug" component={SubmittingAGoodBug}/>
      <Route path="general-questions" component={GeneralQuestions}/>

      <Route path="licensing-and-encryption-keys" component={Keys}/>
      <Route path="licensing" component={Keys}/>
      <Route path="keys" component={Keys}/>

      <Route path="usage-logs" component={UsageLogs}/>
      <Route path="facemap-encryption-keys" component={FaceMapEncryptionKeys}/>

      <Route path="quick-start-guide" component={Docs}/>
      <Route path="zoom-overview" component={Docs}/>

      <Route path="getting-started" component={GettingStarted}/>
      <Route path="advanced-developer-guide" component={Docs}/>

      <Route path="usage-console" component={UsageConsole}/>
      <Route path="server-dashboard-demo" component={UsageConsole}/>

      <Route path="spoof-bounty-program" component={SpoofBountyProgram}/>
      <Route path="quote" component={Quote} />
      <Route path="server-access" component={Quote} /> {/* Don't change this path without changing logic at the top of the quote component */}

      <Route path="zoom-audit-trail" component={RetrievingImagesGuide}/>
      <Route path="data-types" component={RetrievingImagesGuide}/>

      <Route path="string-customization-guide" component={StringCustomizationGuide}/>
      <Route path="matching-guide" component={MatchingGuide}/>

      {/* new url for usability and success */}
      <Route path="zoom-user-experience-details" component={ZoomUserExperienceDetails}/>
      <Route path="usability-and-success" component={ZoomUserExperienceDetails}/>
      <Route path="bias-and-success-rates" component={ZoomUserExperienceDetails}/>

      <Route path="age-estimation-guide" component={AgeCheckGuide}/>
      <Route path="age-check-guide" component={AgeCheckGuide}/>
      <Route path="photo-id-match-guide" component={PhotoIDMatchGuide}/>
      <Route path="user-experience-best-practices" component={UserExperienceBestPractices}/>
      <Route path="zoom-short-expiration-wildcard-licenses" component={ZoomShortExpirationWildcardLicenses}/>
      <Route path="zoom-configuration-options" component={ZoomConfigurationOptions}/>
      <Route path="zoom-sdk-size-and-app-thinning" component={ZoomSdkSizeAndAppThinning}/>
      <Route path="zoom-client-side-security-methodologies" component={ZoomClientSideSecurityMethodologies}/>
      <Route path="video-tutorials" component={VideoTutorials}/>
      <Route path="removing-development-mode-watermark" component={RemoveDevMode}/>

      {/* Two zoom-docker-help is old path */}
      <Route path="zoom-docker-help" component={ZoomDockerHelp}/>
      <Route path="zoom-server-quickstart" component={ZoomDockerHelp}/>

      <Route path="server-sdk-overview" component={ServerSDKOverview}/>

      <Route path="1-to-n-search" component={Search1N}/>

      <Route path="2d-spoof-check" component={SpoofCheck2D}/>

      <Route path="zoom-browser-docker-help" component={ZoomBrowserDockerHelp}/>
      <Route path="zoom-ios" component={ZoomIosIntegration}/>
      <Route path="zoom-android" component={ZoomAndroidIntegration}/>
      <Route path="zoom-server-rest-api" component={ZoomServerRESTAPI}/>
      <Route path="standard-server-rest-api" component={StandardServerRESTAPI}/>
      <Route path="ui-customization" component={UICustomization}/>
      <Route path="technical-support" component={TechnicalSupport}/>
      <Route path="2d-single-image-guidelines" component={MatchingGuide}/>
      <Route path="security-best-practices" component={SecurityBestPractices}/>
      <Route path="compatibility" component={Compatibility}/>
      <Route path="server-integration" component={ServerIntegration}/>
      <Route path="updating" component={Updating}/>
      <Route path="release-practices" component={ReleasePractices}/>
      <Route path="troubleshooting-server" component={TroubleshootingServer}/>
      <Route path="technical-specs" component={TechnicalSpecs}/>
      <Route path="session-tokens" component={SessionTokens}/>
      <Route path="going-production-overview" component={GoingProductionOverview}/>
      <Route path="new-release-info" component={NewReleaseInfo}/>
      <Route path="zoom-server-console" component={ZoomServerConsole}/>
      <Route path="standard-server-and-dashboard" component={StandardServerAndDashboard}/>
      <Route path="photo-id-anti-spoofing-and-anti-tampering" component={PhotoIdAntiSpoofingAndAntiTampering}/>
      <Route path='zoom-identity-check' component={
        function() {
          // dummy component to allow this route
          return null;
        }
      }/>
      <Route path="*" component={Docs}/>
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// ./src/js/sdk-routes.jsx